import React, {useEffect, useRef, useState} from 'react';
import axios from "axios";
import QueryString from "qs";
import "./ChatBox.css";
import botConfig from '../../config/config';
import config from 'config'
import Lottie from 'react-lottie';
import animationData from './img/animation-loader.json';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
};
const ChatBox = (props) => {
    const {firstMessage, olderMessages} = props
    const [userChat, setUserChat] = useState('');
    const [messages, setMessages] = useState([]);
    const [messageType, setmessageType] = useState('');
    const [cacheData, setCacheData] = useState('');
    const [mobile, setMobile] = useState('');
    const [language, setLanguage] = useState('');
    const [isLoading, setIsLoading] = useState(false)


    let getToken = () => {
        return new Promise(async (resolve, reject) => {

            if (typeof caches === 'undefined') reject("cache is undefined");

            const cacheStorage = await caches.open(fetchTokenFromCache.cacheName);
            const cachedResponse = await cacheStorage.match(fetchTokenFromCache.url);

            if (!cachedResponse || !cachedResponse.ok) {
                reject("rejection while fetching cache")
            }

            let item = await cachedResponse.json()
            resolve(item)
        })
    }

    const fetchTokenFromCache = {cacheName: 'token', url: `${botConfig.cacheURL}`}

    useEffect(() => {
        if (olderMessages)
            setMessages(olderMessages)
    }, [])


    useEffect(() => {
        if (props.notifyClose) {
            props.setOlderMessages(messages)
        }
    }, [props.notifyClose])


    const userChatMessageHandler = (event) => {
        setUserChat(event.target.value);
    }

    const minimizeChatBox = (e) => {
        e.preventDefault();
        props.setMinimizeChat(true);
        props.setOlderMessages(messages)
    }

    const closedWebBot = (cacheName) => {
        props.closeChatWindow(cacheName);
        setMessages("");
        props.setUserId('')
        setmessageType('')
        localStorage.clear();
        setCacheData('')
        setMobile('')
        if ("caches" in window) {
            caches.delete(cacheName).then(function (res) {
                return res;
            });
        }
    }

    const messagesEndRef = useRef(null)

    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({behavior: "smooth"})
    }

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const messageSubmitHandler = async (e) => {

        e.preventDefault();
        const msg = userChat;
        const payload = QueryString.stringify({
            'MSG': userChat,
            'msg_type': messageType,
            'mobile': mobile,
            'user_id': props.id,
            "language": language
        });

        try {
            let token = cacheData
            if (token === '') {
                token = await getToken()
            }
            const requestConfig = {

                method: 'post',
                url: `${config.BOT_URL}send-msg/`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': token,
                },
                data: payload
            };
            setMessages([...messages, {me: msg}]);
            setUserChat("");
            setCacheData(token)
            if (userChat !== "") {
                setIsLoading(true)
                let response = await axios(requestConfig);
                setIsLoading(false)
                let {data} = response;
                if (data) {
                    setmessageType(data.msg_type)
                }
                if (data) {
                    setLanguage(data.language)
                }

                if (messageType == "mobile") {
                    setMobile(userChat)
                }

                setMessages([...messages, {me: msg}, data]);
            }

        } catch (err) {
            if (err.response && err.response.status === 413) {
                setMessages([...messages, { message: `Oops! something went wrong` }]);
            }
            console.log(err);
        }
    }

    return (
        <div style={{
            display: !props.notifyClose ? 'block' : 'none'
        }}>
            <div className="modalBackground">
                <div className="chat-title">
                    <img src={require("./img/profile-2.webp")} alt='' className="Profile" style={{
                        width: "48px"
                    }}/>
                    <div className="modalheader">
                        <span className="Revfin-Bot">Virat</span>
                        <span className="I-am-here-to-help-yo">I am here to help you!</span>
                    </div>
                    <div className='bi bi-dash minimize' onClick={(e) => {
                        minimizeChatBox(e)
                    }}/>
                    <img src={require("./img/x-circle-fill.webp")}
                         alt=''
                         className="x-circle-fill" onClick={() => {
                        closedWebBot("token")
                    }} style={{
                        width: "24px"
                    }}/>
                </div>
                <div className='scroll-bar-body'>
                    {/* <ScrollToBottom style={{ height: "340px", marginRight: "0px", width: 'thin' }}> */}
                    <div className="body chat-bot-section">
                        <div className="container scroller">
                            <div className='message'>
                                <div className="left">
                                    <div className="row">
                                        <div className="col-lg-6 virat-img">
                        <span>
                          <img src={require("./img/profile-chat-section.webp")} alt='' style={{
                              width: "48px"
                          }}/>
                        </span>
                                        </div>
                                    </div>

                                    {props.loader ?
                                        <div className="left-message">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="virat-loader">
                                                        <Lottie
                                                            options={defaultOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : (<div>
                                            <div className="row">
                                                <div className="col-lg-12 ">
                                                    <div className="virat-reply">
                                                        <p>{firstMessage && firstMessage.message}</p>
                                                        <p>{firstMessage && firstMessage.footer}</p>
                                                    </div>
                                                    {firstMessage && firstMessage.buttons &&
                                                        <form onSubmit={(e) => messageSubmitHandler(e)}>
                                                            {firstMessage && firstMessage.buttons.map((button) => {
                                                                return (
                                                                    <button name="MSG" value={button}
                                                                            onClick={userChatMessageHandler}
                                                                            className="chat-button" onKeyPress={(e) => {
                                                                        e.key === 'Enter' && e.preventDefault();
                                                                    }}>{button}</button>
                                                                )
                                                            })}
                                                        </form>}
                                                </div>
                                            </div>
                                        </div>)}
                                </div>
                                {messages && messages.map((ele) => {

                                        if (ele.me) {
                                            return (
                                                <div className="user-message">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                              <span>
                                <p className='me-message'>{ele.me}</p>
                              </span>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                              <span>
                                <img src={require("./img/profile-2.png")} alt='' className="Profile-2"/>
                              </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        } else if (ele.me === "") {
                                            return;
                                        } else if (ele.message.includes("https://onelink.to/t9kh3u")) {
                                            let data = ele.message.split("-")
                                            return (
                                                <div className="left">
                                                    <div className="row">
                                                        <div className="col-lg-6 virat-img">
                              <span>
                                <img src={require("./img/profile-chat-section.webp")} alt='' style={{
                                    width: "48px"
                                }}/>
                              </span>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="virat-reply">
                                                                <p>{data[0]}</p>
                                                                <a href="https://onelink.to/t9kh3u" target="_blank" style={{
                                                                    color: '#007bff'
                                                                }}>{data[1]}</a>
                                                                <p>{ele.footer}</p>
                                                            </div>
                                                            {ele.buttons && <form onSubmit={(e) => messageSubmitHandler(e)}>
                                                                {ele.buttons.map((button) => {
                                                                    return (
                                                                        <button name="MSG" value={button}
                                                                                onClick={userChatMessageHandler}
                                                                                className="chat-button" onKeyPress={(e) => {
                                                                            e.key === 'Enter' && e.preventDefault();
                                                                        }}>{button}</button>
                                                                    )
                                                                })}
                                                            </form>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div className="left">
                                                    <div className="row">
                                                        <div className="col-lg-6 virat-img">
                              <span>
                                <img src={require("./img/profile-chat-section.webp")} alt='' style={{
                                    width: "48px"
                                }}/>
                              </span>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="virat-reply">
                                                                <p>{ele.message}</p>
                                                                <p>{ele.footer}</p>
                                                            </div>
                                                            {ele.buttons && <form onSubmit={(e) => messageSubmitHandler(e)}>
                                                                {ele.buttons.map((button) => {
                                                                    return (
                                                                        <button name="MSG" value={button}
                                                                                onClick={userChatMessageHandler}
                                                                                className="chat-button" onKeyPress={(e) => {
                                                                            e.key === 'Enter' && e.preventDefault();
                                                                        }}>{button}</button>
                                                                    )
                                                                })}
                                                            </form>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    }
                                )}
                                {isLoading &&
                                    <div className="left">
                                        <div className="row">
                                            <div className="col-lg-6 virat-img">
                          <span>
                            <img src={require("./img/profile-chat-section.webp")} alt='' style={{
                                width: "48px"
                            }}/>
                          </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="virat-loader">
                                                    <Lottie
                                                        options={defaultOptions}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>}

                                <div style={{float: "left", clear: "both"}}
                                     ref={messagesEndRef}>
                                </div>
                            </div>

                        </div>

                    </div>
                    {/* </ScrollToBottom> */}
                </div>
                <form className="message-box" id="mymsg" onSubmit={(e) => messageSubmitHandler(e)}>
                    <div className='User-input-box'>
                        <input type="text" id="MSG" name="MSG" autoComplete='off' value={userChat}
                               className="Type-your-message" placeholder="Type your message…"
                               onChange={(e) => userChatMessageHandler(e)}/>
                    </div>
                    <button type="submit" className="submitBtn" onKeyPress={(e) => {
                        e.key === 'Enter' && e.preventDefault();
                    }}><img src={require("./img/paper-plane-tilt-fill.webp")}
                            className="paper-plane-tilt-fill" alt='' style={{
                        width: "24px"
                    }}/>
                    </button>
                </form>

            </div>
        </div>
    );
}

export default ChatBox;



// WEBPACK FOOTER //
// ./src/components/website-bot/ChatBox.js